module.exports = __webpack_public_path__ + "kaitak-ogp-lp6-220623.828499741d6575e9c241.jpg";